export const STEPS=["Business Profile","Location & Operations","Coverage Needs","Current Premiums"];
export const CARRIERS=[
  {value:"",label:"Select current carrier..."},
  {value:"progressive",label:"Progressive Commercial"},
  {value:"travelers",label:"Travelers"},
  {value:"nationwide",label:"Nationwide"},
  {value:"liberty",label:"Liberty Mutual"},
  {value:"chubb",label:"Chubb"},
  {value:"hartford",label:"The Hartford"},
  {value:"zurich",label:"Zurich"},
  {value:"employers",label:"Employers Insurance"},
  {value:"guard",label:"Guard Insurance (Berkshire)"},
  {value:"markel",label:"Markel"},
  {value:"amtrust",label:"AmTrust Financial"},
  {value:"acuity",label:"Acuity Insurance"},
  {value:"cincinnati",label:"Cincinnati Financial"},
  {value:"westfield",label:"Westfield Insurance"},
  {value:"hanover",label:"The Hanover Insurance Group"},
  {value:"sentry",label:"Sentry Insurance"},
  {value:"usli",label:"USLI (United States Liability)"},
  {value:"state_auto",label:"State Auto"},
  {value:"colony",label:"Colony Insurance (Argo Group)"},
  {value:"evanston",label:"Evanston Insurance (Markel)"},
  {value:"fednat",label:"FedNat"},
  {value:"citizens",label:"Citizens Property Insurance"},
  {value:"universal",label:"Universal Insurance Holdings"},
  {value:"lloyds",label:"Lloyd's of London"},
  {value:"other",label:"Other / Not Sure"},
];


export const ALLOC_OPTIONS=[
  {value:"equipment",label:"🔧 Equipment & Fleet",roi:1.35,desc:"~35% ROI via productivity gains"},
  {value:"payroll",label:"👷 Hire Additional Crew",roi:1.28,desc:"Industry avg revenue-per-employee"},
  {value:"debt",label:"💳 Pay Down Business Debt",roi:1.18,desc:"Based on avg 8.5% business loan rate"},
  {value:"marketing",label:"📣 Sales & Marketing",roi:1.42,desc:"Contractor marketing avg 42% ROI"},
  {value:"cash",label:"🏦 Operating Reserve",roi:1.06,desc:"6% high-yield business account"},
];

// Bold stat card used throughout results